<template>
    <button
        type="button"
        :data-interface-target="authorized ? 'profile-promo-code' : 'profile-promo-code-anon'"
        :class="[$style.block, { [$style.authorized]: authorized }]"
        @click="promoCodeStore.openModal('profile-promo-code')"
    >
        <img
            :src="JarImg"
            alt=""
            :class="$style.jar"
        />
        <Typography
            size="s"
            :class="$style.text"
        >
            <template v-if="authorized">
                <span :class="$style.title">{{ $tr('promoCode.profileTitle') }}</span>
                <br />
                {{ $tr('promoCode.profileDescription') }}
            </template>
            <template v-else>
                <span :class="$style.lead">{{ $tr('promoCode.profileAnonLead') }}</span>
                {{ $tr('promoCode.profileAnonDescription') }}
            </template>
        </Typography>
    </button>
</template>
<script setup lang="ts">
import JarImg from '@/assets/images/artwork-jar.webp'
import Typography from '@/components/Typography.vue'
import { usePromoCodeStore } from '@/store/promo-code/promo-code-store'

defineProps<{ authorized?: boolean }>()

const promoCodeStore = usePromoCodeStore()
</script>
<style module>
.block {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 0;
    border: none;
    background: none;
    text-align: start;
    cursor: pointer;
}

.jar {
    flex-shrink: 0;
    width: 64px;
    height: 64px;
    object-fit: contain;
}

.text {
    color: var(--white-60);
}

.title,
.lead {
    font-weight: var(--font-weight-accent);
}

.title {
    color: var(--lavander-400);
}

.lead {
    color: var(--white);
}

.block:hover .title {
    color: var(--lavander-600);
}

@media (--desktop-small-plus) {
    .block {
        gap: 8px;
        max-width: 480px;
    }

    .jar {
        width: 56px;
        height: 56px;
    }

    .lead {
        display: none;
    }

    .authorized {
        flex-direction: column;
        align-items: flex-start;
        gap: 16px;
        max-width: 440px;
    }

    .authorized .jar {
        width: 72px;
        height: 72px;
    }
}

@media (--desktop-small-plus) and (hover: hover) and (prefers-reduced-motion: no-preference) {
    .jar {
        will-change: transform;
    }

    .block:hover .jar {
        transform-origin: 50% 90%;
        animation: jar-shake 1.2s ease-in-out infinite;
    }
}

@keyframes jar-shake {
    0%,
    40%,
    100% {
        transform: rotate(0);
    }
    8% {
        transform: rotate(-6deg);
    }
    16% {
        transform: rotate(5deg);
    }
    24% {
        transform: rotate(-3deg);
    }
    32% {
        transform: rotate(2deg);
    }
}
</style>
